module.exports = {
  network: require('./networkTheme.js'),
  networkTheme: require('./networkThemeTheme.js'),
  outerverse: require('./outerverseTheme.js'),
  outside: require('./outsideTheme.js')
};
